import { NavBar } from 'components/NavBar/NavBar'
import { clearEligibleEmployees, getFoodEligibleEmployees } from 'features/food/foodSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { getParams, handlePagination } from 'utils/helpers'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Options } from 'components/Options/Options'
import { Pagination } from 'components/Pagination/Pagination'
import { FoodEmployeeSettingsModal, IFoodEmployeeSettingsModalState } from './FoodEmployeeSettingsModal'
import { IGetAllFoodEligibleEmployeesSingleResponse } from 'types/api/foodApi.interface'

export const FoodEligibleEmployees = () => {

    const [modal, setModal] = useState<{ open: boolean, value: IFoodEmployeeSettingsModalState }>({ open: false, value: null })
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { eligibleEmployees } = useSelector((store: RootState) => store.food)
    useQueryPagination({ fetchFunctions: [getFoodEligibleEmployees], cleanUpFunctions: [clearEligibleEmployees], params })

    const handleOpenModal = (item: IGetAllFoodEligibleEmployeesSingleResponse) => {
        setModal({
            open: true, value: {
                id: item?.id || null,
                maxMealsPerOperationalDay: item?.foodSettings?.maxMealsPerOperationalDay || null,
                provisioningMode: item.foodSettings?.id ? provisioningModes.find(p => item.foodSettings.provisioningMode == p.value) : null,
                foodSupplier: item.foodSettings?.foodSupplier?.id ? { label: item?.foodSettings?.foodSupplier?.name, value: item?.foodSettings?.foodSupplier?.id } : null,
                selectedMealTypes: item?.foodSettings?.selectedMealTypes.map(t => ({ value: t.mealType.id, label: t.mealType.name })) || [{ value: null, label: null }],
            }
        })
    }


    const columns: IHonestTableColumn<any>[] = [
        { id: 'name', header: 'NAME', cell: (item) => item.firstName + ' ' + item.lastName },
        { id: 'supplier', header: 'SUPPLIER', cell: (item) => item.foodSettings?.foodSupplier?.name || '/' },
        { id: 'provisioningMode', header: 'PROVISIONING MODE', cell: (item) => provisioningModes.find(mode => mode.value === item?.foodSettings?.provisioningMode)?.label || '/' },
        { id: 'maxMeals', header: 'MAXIMUM MEALS PER DAY', cell: (item) => item?.foodSettings?.maxMealsPerOperationalDay || '/' },
        { id: 'mealTypes', header: 'MEAL TYPES', cell: (item) => item?.foodSettings?.selectedMealTypes?.map((type) => type.mealType.name).join(', ') || '/' },
        {
            id: 'actions',
            header: '',
            align: 'right',
            cell: (item) => (
                <span onClick={(e) => e.stopPropagation()}>
                    <Options item={item} title='Food Employee Settings' openModal={() => handleOpenModal(item)} />
                </span>
            ),
        },
    ]

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <H1WithBack arrow title='Eligible Employees' />
            </Flex>
            {!eligibleEmployees.data?.length ? (
                <NoItems title='Eligible Employees' />
            ) : (
                <HonestTable columns={columns} data={eligibleEmployees.data} keyField='id' />
            )}
            {modal.open && <FoodEmployeeSettingsModal closeModal={() => setModal({ open: false, value: null })} value={modal.value} />}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(eligibleEmployees.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}

export const provisioningModes = [{ value: 1, label: 'Mess Or Hall' }, { value: 2, label: 'Packout' }, { value: 3, label: 'OptOut' }]